<template>
    <div class="subs_container">
      <div class="subs_header">Billing</div>
      <div class="subs_">
        <div class="subs_header_pay">Payment method</div>
  
        <div class="subs_header_no_pay">No payment method set</div>
      </div>
      <div class="subs_">
        <div class="subs_header_pay">Current plan</div>
  
        <div class="subs_header_no_pay">
          You currently do not have an active subscriprion plan
        </div>
      </div>
      <div class="subs_plan">
        <div class="subs_sub">
          <div class="subs_header_pay">View plan details</div>
          <div>
            <img src="@/assets/img/uprock_opac.svg" alt="" />
          </div>
        </div>
        <div class="subs_plan_list">
          <div>
            <div class="subs_text">Monthly</div>
            <div class="subs_upgrade_cont">
              <button class="subs_upgrade" v-for="(plan, index) in plans" :key="index">
                Upgrade to {{ plan.type_version }} (${{ plan.cost }} / month)
              </button>
            </div>
          </div>
          <div>
            <div class="subs_text">Yearly <span class="yearly_off"> 2 months off </span> 🎁</div>
            <div class="subs_upgrade_cont">
              <button
                class="subs_upgrade_yearly"
                v-for="(plan, index) in plans"
                :key="index"
              >
                Upgrade to {{ plan.type_version }} (${{ plan.cost }} / month)
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    data() {
      return {
        plans: [
          { type_version: "LITE", cost: 49 },
          { type_version: "BASIC", cost: 99 },
          { type_version: "TURBO", cost: 249 },
          { type_version: "PRO", cost: 449 },
  
        ],
      };
    },
  };
  </script>
  <style>
  .subs_header {
    color: #212b36;
    font-family: "Inter", sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 30px;
  }
  .subs_container {
    padding: 35px 55px 106px 55px;
  }
  .subs_header_pay {
    color: #3e3e3e;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }
  .subs_header_no_pay {
    color: #637381;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  .subs_ {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 41px;
  }
  .subs_sub {
    display: flex;
    gap: 6px;
    align-items: center;
  }
  .subs_plan {
    padding-top: 44px;
  }
  .subs_plan_list {
    display: flex;
    gap: 24px;
    padding-top: 16px;
  }
  .subs_upgrade {
    color: #4764d5;
    font-family: "Inter", sans-serif;
    border-radius: 6px;
    border: 1px solid #4764d5;
    padding: 10px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    width: fit-content;
    background: #fbfcfd;
  }
  .subs_upgrade_yearly {
    color: #fff;
    font-family: "Inter", sans-serif;
    border-radius: 6px;
    border: 1px solid #4764d5;
    padding: 10px;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    width: fit-content;
    background: #3056d3;
  }
  .subs_upgrade_cont {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding-top: 13px;
  }
  .yearly_off {
    color: #27ae60;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-style: italic;
    font-weight: 900;
    line-height: 24px;
  }
  .subs_text {
    color: #637381;
    font-family: "Inter", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px;
  }
  @media screen and (max-width: 992px) {
    .subs_container{
      padding: 35px 20px 140px 20px;
    }
  }
  </style>